export default {
  FETCH_ALL: 'USERS/FETCH_ALL',
  LIMIT: 'USERS/LIMIT',
  SET_ALL: 'USERS/SET_ALL',
}
